module.exports = __webpack_public_path__ + "static/media/plus.24e2e1c2.png";